"use client";
import Image from "next/image";
import { useEffect, useState } from "react";

const OptimizedImage = ({
    src,
    alt,
    className = "",
    quality = 75,
    style,
    fill,
    unoptimized = false,
    onLoad,
    onError,
    ...props
}) => {
    const FALLBACK_IMAGE = "/img/logo.avif";
    const getSafeSrc = (url) => {
        if (!url) return FALLBACK_IMAGE;
        try {
            return encodeURI(decodeURI(url));
        } catch (e) {
            return url;
        }
    };

    const [imgSrc, setImgSrc] = useState(() => getSafeSrc(src));
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setImgSrc(getSafeSrc(src));
        setIsLoading(true);
        setIsError(false);
    }, [src]);

    return (
        <>
            <style jsx global>{`
                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
                .img-loading-shimmer {
                    /* Tạo dải màu xám - trắng - xám */
                    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                    background-size: 200% 100%;
                    /* Chạy animation quét sáng */
                    animation: shimmer 1.5s infinite linear;
                }
            `}</style>

            <Image
                {...props}
                src={imgSrc}
                alt={alt || "Hình ảnh"}
                quality={quality}
                unoptimized={unoptimized}
                onLoad={(event) => {
                    if (event.target.naturalWidth === 0) setImgSrc(FALLBACK_IMAGE);
                    setIsLoading(false);
                    onLoad?.(event);
                }}

                onError={(event) => {
                    if (!isError && imgSrc !== src) {
                        setImgSrc(src);
                        setIsError(true);
                    } else {
                        setImgSrc(FALLBACK_IMAGE);
                    }
                    setIsLoading(false);
                    onError?.(event);
                }}

                className={`${className} ${isLoading ? 'img-loading-shimmer' : ''}`}
                style={{
                    ...style,
                    filter: isLoading ? 'blur(5px) grayscale(100%)' : 'blur(0) grayscale(0)',
                    transition: 'filter 0.5s ease-out',
                    objectFit: fill ? "cover" : (style?.objectFit || "cover"),
                }}
                fill={fill}
            />
        </>
    );
};

export default OptimizedImage;
